export const clarityScoresContent = `
Every review produces a clarity score between 0 and 100. This score reflects how clear, complete, and unambiguous your requirements are based on multiple weighted dimensions.

{% score-range range="90–100" label="Excellent" color="green" description="Ready for engineering. Clear, unambiguous, with explicit acceptance criteria." /%}
{% score-range range="70–89" label="Good" color="blue" description="Minor improvements recommended. A few assumptions or edge cases to address." /%}
{% score-range range="50–69" label="Needs Work" color="yellow" description="Significant ambiguities detected. Multiple rewrites and clarifications suggested." /%}
{% score-range range="0–49" label="Critical" color="red" description="High risk of misinterpretation. Major restructuring recommended before sharing with engineering." /%}

{% callout type="info" title="Score Dimensions" %}
Specificity & measurability • Completeness of acceptance criteria • Absence of ambiguous language • Dependency clarity • Testability of requirements • Consistency across requirements
{% /callout %}
`;
